import { useState, useEffect, useCallback, ChangeEvent, useRef } from "react";
import styled from "styled-components";
import {
  Paper,
  Grid,
  Box,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Checkbox,
  Toolbar,
} from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

import {
  Tooltip,
  ButtonSubmit,
  ButtonCancel,
  SearchInput,
  Select,
  Loading,
  DialogYesNo,
  Dialog,
} from "components/shared";
import { Icons } from "components/Icons";
import { AddreeseeDetails } from "components";
import { RowNoData, TableDownload } from "components/tables";
import { useAddreesse, useTable } from "hooks";
import { IOrder, IAddressee } from "config/interfaces";
import { TableTitle } from "./styles";
// import ListInstallsContext from "context/ListInstallsContext";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toolbar: {
      paddingBottom: theme.spacing(2),
      borderRadius: "4px",
      background: "var(--backgroundContent)",
      width: "100%",
      "& .MuiToolbar-regular": {
        padding: 0,
      },
    },
    table: {
      borderRadius: "4px",
      background: "var(--backgroundContent)",
      width: "100%",
    },
    margin: {
      margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      maxWidth: "calc(100% - 12px)",
    },
    input: {
      "& .MuiInputBase-input": {
        boxShadow: "none",
        fontSize: "1.2rem",
        fontWeight: "500",
        textTransform: "uppercase",
      },
    },
    checkbox: {
      "&.MuiCheckbox-colorSecondary.Mui-checked": {
        color: "var(--orange)",
      },
      "& .MuiSvgIcon-root": {
        width: "1.4rem",
      },
    },
  })
);
interface TableProps {
  title?: string;
}

const filters: IOrder.SelectField[] = [
  {
    label: "GRUPO",
    value: "group",
  },
  // {
  //   label: "STATUS",
  //   value: "status",
  // },
];

interface HeadCell {
  disableSorting?: boolean;
  id: keyof IAddressee.Table;
  label: string;
}

// TABLE HEAD
const headCells: HeadCell[] = [
  { id: "NMUSUARIO", label: "NOME" },
  { id: "TELEFONE", label: "TELEFONE" },

  { id: "ENDECOMPL", label: "COMPLEMENTO" },
  { id: "DSGRUPOUSUARIO", label: "GRUPO" },
  // { id: "STAPP", label: "STATUS APLICATIVO" },
];

const SelectedItems = styled.span`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 1.2rem;
`;

interface DataState {
  filter: string | null;
  status?: string;
  group?: string;
}

const initialState: DataState = {
  filter: null,
  status: "2",
  group: "0",
};

const messageInactivateUserText = (
  <>
    <p>
      A inativação do destinatário o impossibilitará de utilizar o Modulocker.
    </p>
    <p>Confirma a inativação?</p>
  </>
);
const messageInactivateUsersText = (
  <>
    <p>
      A inativação dos destinatários os impossibilitarão de utilizarem o
      Modulocker.
    </p>
    <p>Confirma a inativação?</p>
  </>
);
const messageDeleteUserText = (
  <>
    <p>
      A exclusão do destinatário o impossibilitará de utilizar o Modulocker.
    </p>
    <p>Confirma a exclusão?</p>
  </>
);
const messageDeleteUsersText = (
  <>
    <p>
      A exclusão dos destinatários os impossibilitarão de utilizarem o
      Modulocker.
    </p>
    <p>Confirma a exclusão?</p>
  </>
);
const messageActivateUserText = (
  <>
    <p>Confirma a reativação do destinatário?</p>
  </>
);
const messageActivateUsersText = (
  <>
    <p>Confirma a reativação dos destinatários?</p>
  </>
);

export default function TableAddressees({ title }: TableProps) {
  const [data, setData] = useState(initialState);
  const [rows, setRows] = useState([] as IAddressee.Addressee[]);
  // rows é onde fica a lista
  const [search, setSearch] = useState("");
  const [selectedAddreesee, setSelectedAddreesee] = useState(
    {} as IAddressee.Addressee
  );
  const [openDetails, setOpenDetails] = useState(false);

  const [openInactivate, setOpenInactivate] = useState(false);
  const [openActivate, setOpenActivate] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  // const { update } = useContext(ListInstallsContext);
  const [filterFn, setFilterFn] = useState({
    fn: (items: any) => {
      return items;
    },
  });
  const {
    loading,
    addreesses,
    addreesses: records,
    groupOptions,
    getAddreessesByFilters,
    setPagination,
    getAllAddreesses,
    updateStatusAddressees,
    selectedRows,
    setSelectedRows,
    successActivate,
    successDelete,
    successInactivate,
    setSuccessInactivate,
    setSuccessActivate,
    setSuccessDelete,
    IDMCM,
  } = useAddreesse();

  const {
    TblContainer,
    TblHead,
    TblPagination,
    recordsAfterPagingAndSorting,
    actions,
    setActions,
    allowedActions,
    setPage,
  } = useTable({
    records,
    headCells,
    filterFn,
    config: { checkbox: true, actions: true },
    setPagination,
  });
  let inputSearchRef = useRef<HTMLInputElement | null>(null);

  const classes = useStyles();

  useEffect(() => {
    setRows(records);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addreesses]);

  useEffect(() => {
    const allStatus = selectedRows.map((addresse) => addresse.STUSUARIO);
    const filteredStatus = allStatus.filter(
      (este, i, arr) => arr.indexOf(este) === i
    );
    if (filteredStatus.length > 1) {
      return setActions({ ...actions, isAllow: false });
    }

    switch (String(filteredStatus[0])) {
      case "0":
        return setActions(allowedActions.active);
      case "1":
        return setActions(allowedActions.inactivate);
      case "2":
        return setActions(allowedActions.delete);
      default:
        return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedRows]);

  const onSelectAll = useCallback(
    (selectedRows: Array<IAddressee.Addressee>) => {
      setSelectedRows(selectedRows);
    },
    [setSelectedRows]
  );

  const onClick = useCallback(
    (addreesee: IAddressee.Addressee, open: boolean) => {
      setSelectedAddreesee(addreesee);
      setOpenDetails(open);
    },
    []
  );

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setPage(0);
    let target = e.target;
    setSearch(target.value);
    setFilterFn({
      fn: (items: any) => {
        if (target.value === "") return items;
        else
          return items.filter(
            (x: any) =>
              x.NMUSUARIO.toLowerCase().includes(target.value.toLowerCase()) ||
              String(x.TELEFONE)
                .toLowerCase()
                .includes(target.value.toLowerCase())
          );
      },
    });
  };

  const handleSelect = useCallback(
    (
      event: React.ChangeEvent<HTMLInputElement>,
      addreesee: IAddressee.Addressee
    ) => {
      if (event.target.checked) {
        let newSelectedRows = [...selectedRows];
        newSelectedRows.push(addreesee);
        setSelectedRows(newSelectedRows);
      } else {
        const newSelectedRows = selectedRows.filter(
          (element) => element.IDUSUARIO !== addreesee.IDUSUARIO
        );
        setSelectedRows(newSelectedRows);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [selectedRows]
  );

  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      // const newSelecteds = rows.map((n) => n.IDUSUARIO.toString());
      return onSelectAll(rows);
    }
    onSelectAll([] as Array<IAddressee.Addressee>);
  };

  const isSelected = (userId: string) =>
    selectedRows.findIndex(
      (element) => element.IDUSUARIO === Number(userId)
    ) !== -1;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, checked } = event.target;

    const newState = { ...data, [name]: value ? value : checked };
    setData(newState);
  };

  const handleFilterClick = () => {
    setPage(0);
    switch (data.filter) {
      case "status":
        return getAddreessesByFilters({ IDSTAPP: data.status });
      case "group":
        return getAddreessesByFilters({
          // FLUSERADM: data.group === "ADMINISTRADOR" ? 1 : 0,
          FLUSERADM: data?.group as any,
        });
      default:
        return;
    }
  };

  const handleCancelFilter = () => {
    setData({ ...data, filter: null });
    setSearch("");
    getAllAddreesses();
  };

  const handleEndDialogs = (type: string) => {
    onSelectAll([] as Array<IAddressee.Addressee>);
    setSelectedRows([] as Array<IAddressee.Addressee>);
    setSelectedAddreesee({} as IAddressee.Addressee);
    setData(initialState);
    if (type === "inactivate") {
      return setSuccessInactivate(false);
    }
    if (type === "delete") {
      return setSuccessDelete(false);
    }
    return setSuccessActivate(false);
  };

  const selectedItems =
    selectedRows.length > 0 ? String(selectedRows.length).padStart(2, "0") : 0;

  // const adressComplete = (adress: any) => {
  //   const string = `${adress.LOGRADOURO}, ${adress.NUMERO} - ${adress.BAIRRO} | ${adress.DSCIDADE} - ${adress.DSUF} | CEP: ${adress.CEP} `;
  //   return string;
  // };

  // const endComplement = (adressArray: any) => {
  //   if (adressArray.length === 0) return "";
  //   let finalString = "";
  //   adressArray.forEach((item: any) => {
  //     if (item.DSCOMPLEMENTO) {
  //       if (item.VLCOMPLEMENTO) {
  //         finalString =
  //           finalString + item.DSCOMPLEMENTO + " " + item.VLCOMPLEMENTO + " | ";
  //       } else {
  //         finalString = finalString + item.DSCOMPLEMENTO + " " + "-" + " | ";
  //       }
  //     }
  //   });
  //   return finalString;
    // const string = `${adressArray[0]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[0]?.VLCOMPLEMENTO ?? ""
    // } \n
    //   ${adressArray[1]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[1]?.VLCOMPLEMENTO ?? ""
    // } \n
    //   ${adressArray[2]?.DSCOMPLEMENTO ?? ""} ${
    //   adressArray[2]?.VLCOMPLEMENTO ?? ""
    // }`;
    // return string;
  // };

  return (
    <>
      {IDMCM && (
        <>
          <Paper className={classes.toolbar} elevation={0}>
            <Toolbar>
              <Grid container spacing={2} justifyContent="space-between">
                <Grid item xs={6} md={5}>
                  <SearchInput
                    ref={inputSearchRef}
                    value={search}
                    onChange={handleSearch}
                    placeholder="POR NOME / TELEFONE"
                  />
                </Grid>

                <Grid item xs={6} md={6} alignItems="flex-end">
                  <Box display="flex" justifyContent="flex-end">
                    {recordsAfterPagingAndSorting().length > 0 && (
                      <TableDownload
                        dataToConvert={records.sort((a: any, b: any) =>
                          a.NMUSUARIO > b.NMUSUARIO ? 1 : -1
                        )}
                        type="destinatarios"
                      />
                    )}
                    <Select
                      type="mainSelect"
                      label="FILTRO"
                      name="filter"
                      choices={filters}
                      value={data.filter}
                      onChange={handleChange}
                    />
                  </Box>
                </Grid>
              </Grid>
            </Toolbar>

            {data.filter && (
              <Toolbar id="toolbar-period" style={{ marginTop: "16px" }}>
                <Grid container spacing={2} justifyContent="flex-end">
                  <Grid item xs={12} md={6}>
                    <Paper style={{ padding: "16px" }}>
                      {data.filter === "group" && (
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={3}>
                            <Select
                              label="GRUPO"
                              name="group"
                              choices={groupOptions}
                              value={data.group}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )}

                      {/* {data.filter === "status" && (
                        <Grid container spacing={2}>
                          <Grid item xs={12} sm={3}>
                            <Select
                              label="STATUS"
                              name="status"
                              choices={statusOptions}
                              value={data.status}
                              onChange={handleChange}
                            />
                          </Grid>
                        </Grid>
                      )} */}

                      <Box mt={3} display="flex" justifyContent="flex-end">
                        <ButtonCancel
                          onClick={handleCancelFilter}
                          style={{ marginRight: "16px" }}
                        >
                          LIMPAR
                        </ButtonCancel>
                        <ButtonSubmit autoFocus onClick={handleFilterClick}>
                          FILTRAR
                        </ButtonSubmit>
                      </Box>
                    </Paper>
                  </Grid>
                </Grid>
              </Toolbar>
            )}
          </Paper>

          {!loading ? (
            <Paper className={classes.table} elevation={0}>
              {title && <TableTitle>{title}</TableTitle>}
              <Grid container alignItems="center">
                <Grid item xs={12} sm={6}>
                  <Box display="flex" alignItems="center" minHeight={48}>
                    <SelectedItems>SELECIONADOS: {selectedItems}</SelectedItems>
                    {/* {selectedItems && actions?.isAllow ? (
                  <ul style={{ display: "inline", marginLeft: "8px" }}>
                    {actions.inactivate && (
                      <Tooltip title="INATIVAR">
                        <IconButton onClick={() => setOpenInactivate(true)}>
                          {" "}
                          <Icons.Disable
                            style={{ fontSize: "20px", color: "var(--orange)" }}
                          />{" "}
                        </IconButton>
                      </Tooltip>
                    )}

                    {actions.delete && (
                      <Tooltip title="EXCLUIR">
                        <IconButton onClick={() => setOpenDelete(true)}>
                          {" "}
                          <Icons.Delete
                            style={{ fontSize: "20px", color: "var(--red)" }}
                          />{" "}
                        </IconButton>
                      </Tooltip>
                    )}

                    {selectedRows.length === 1 && (
                      <Tooltip title="EDITAR">
                        <IconButton
                          onClick={() =>
                            router.push(
                              `/destinatarios/${selectedRows[0].IDUSUARIO}/editar`
                            )
                          }
                        >
                          <Icons.Edit
                            style={{ fontSize: "20px", color: "var(--blue)" }}
                          />
                        </IconButton>
                      </Tooltip>
                    )}

                    {actions.activate && (
                      <Tooltip title="REATIVAR">
                        <IconButton onClick={() => setOpenActivate(true)}>
                          {" "}
                          <Icons.Activate
                            style={{
                              fontSize: "20px",
                              fontWeight: "bold",
                              color: "var(--iconGreen)",
                            }}
                          />{" "}
                        </IconButton>
                      </Tooltip>
                    )}
                  </ul>
                ) : null} */}
                  </Box>
                </Grid>
              </Grid>

              <TblContainer>
                <TblHead
                  numSelected={selectedRows.length}
                  rowCount={rows.length}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {recordsAfterPagingAndSorting().length === 0 ? (
                    <RowNoData />
                  ) : (
                    recordsAfterPagingAndSorting().map(
                      (row: any, index: any) => {
                        const isItemSelected = isSelected(
                          String(row.IDUSUARIO)
                        );
                        const labelId = `enhanced-table-checkbox-${index}`;

                        return (
                          <TableRow
                            hover
                            key={row.IDUSUARIO}
                            role="checkbox"
                            aria-checked={isItemSelected}
                            tabIndex={-1}
                            selected={isItemSelected}
                          >
                            <TableCell padding="checkbox">
                              <Checkbox
                                className={classes.checkbox}
                                checked={isItemSelected}
                                inputProps={{ "aria-labelledby": labelId }}
                                onChange={(
                                  event: React.ChangeEvent<HTMLInputElement>
                                ) => handleSelect(event, row)}
                              />
                            </TableCell>
                            <TableCell align="left">{row.NMUSUARIO}</TableCell>
                            <TableCell align="left">{row.TELEFONE}</TableCell>
                            {/* <TableCell align="left">
                        {adressComplete(row.GRUPOUSUARIO[0].ENDERECO[0])}
                      </TableCell> */}
                            <TableCell align="left">{row.ENDECOMPL}</TableCell>

                            <TableCell align="left">
                              {row.DSGRUPOUSUARIO}
                            </TableCell>
                            {/* <TableCell align="left">{row?.STAPP}</TableCell> */}
                            {/* <TableCell
                        align="left"
                        style={{
                          width: 50,
                          wordBreak: "break-all",
                        }}
                      >
                        {getAddreessesStatusDescription(row.STUSUARIO)}
                      </TableCell> */}
                            <TableCell align="right">
                              <IconButton onClick={() => onClick(row, true)}>
                                <Tooltip title="INFORMAÇÕES">
                                  <Icons.Info fontSize="large" />
                                </Tooltip>
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )
                  )}
                </TableBody>
              </TblContainer>

              <TblPagination />
            </Paper>
          ) : (
            <Box mt={15} mb={15}>
              <Loading />
            </Box>
          )}
        </>
      )}

      <DialogYesNo
        title="Inativar"
        text={
          selectedRows.length > 1
            ? messageInactivateUsersText
            : messageInactivateUserText
        }
        onClose={() => setOpenInactivate(false)}
        onClick={() => {
          updateStatusAddressees(selectedRows, 1);
          setOpenInactivate(false);
        }}
        open={openInactivate}
      />
      <Dialog
        title="Aviso"
        text={
          selectedRows.length > 1
            ? "Destinatários inativados com sucesso!"
            : "Destinatário inativado com sucesso!"
        }
        onClose={() => handleEndDialogs("inactivate")}
        onClick={() => handleEndDialogs("inactivate")}
        open={successInactivate}
      />

      <DialogYesNo
        title="Excluir"
        text={
          selectedRows.length > 1
            ? messageDeleteUsersText
            : messageDeleteUserText
        }
        onClose={() => setOpenDelete(false)}
        onClick={() => {
          updateStatusAddressees(selectedRows, 2);
          setOpenDelete(false);
        }}
        open={openDelete}
      />
      <Dialog
        title="Aviso"
        text={
          selectedRows.length > 1
            ? "Destinatários excluídos com sucesso!"
            : "Destinatário excluído com sucesso!"
        }
        onClose={() => handleEndDialogs("delete")}
        onClick={() => handleEndDialogs("delete")}
        open={successDelete}
      />

      <DialogYesNo
        title="Reativar"
        text={
          selectedRows.length > 1
            ? messageActivateUsersText
            : messageActivateUserText
        }
        onClose={() => setOpenActivate(false)}
        onClick={() => {
          updateStatusAddressees(selectedRows, 0);
          setOpenActivate(false);
        }}
        open={openActivate}
      />
      <Dialog
        title="Aviso"
        text={
          selectedRows.length > 1
            ? "Destinatários reativados com sucesso!"
            : "Destinatário reativado com sucesso!"
        }
        onClose={() => handleEndDialogs("activate")}
        onClick={() => handleEndDialogs("activate")}
        open={successActivate}
      />

      <AddreeseeDetails
        order={selectedAddreesee}
        open={openDetails}
        setOpen={setOpenDetails}
      />
    </>
  );
}
